import {
  ADD_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  SET_SERVER_ERROR,
} from '../constants/ActionTypes';

const INIT_STATE = {
  notifications: null,
  serverError: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const notifications = [...(state.notifications ? state.notifications : []), action.payload];

      return {
        ...state,
        notifications,
      };
    }
    case CLEAR_NOTIFICATIONS: {
      return {
        ...state,
        notifications: null,
      };
    }
    case REMOVE_NOTIFICATION: {
      const notifications = state.notifications
        ? state.notifications.filter((_, index) => index !== action.payload.notificationId)
        : [];

      return {
        ...state,
        notifications,
      };
    }
    case SET_SERVER_ERROR: {
      return {
        ...state,
        serverError: action.payload.serverErrorCode,
      };
    }
    default:
      return state;
  }
};
